<template lang="pug">
div.content.body-reg-student.background-reg-student
  .container
    .row
      .card.reg-student-card
        .card-content.reg-student-card-content
          div.col-md-12
            div.col-md-4.reg-student-img
              img(src="../../assets/Obee_Logo_140@2x.png")
            div.col-md-8.reg-student-title ĐĂNG KÝ TÀI KHOẢN HỌC SINH
            .row
              .col-md-12.reg-student-alert(v-if="error")
                .form-group
                  .alert.alert-danger {{error}}
              .col-md-12(v-if="socialType === 1")
                //- md-fg-input(label='Tên đăng nhập *', v-model='username' :labelFloating='false', type='text' :required='true' 
                //-   placeholder="Nhập" @input="checkUserName")
                .form-group.custom-form-group(:class="[isSubmitStep && (username.length < 3 || this.checkName !== null) ? 'error' : '']")
                  label.control-label Tên đăng nhập *
                  input.form-control(placeholder="Nhập" required v-model="username")
              .col-md-12
                //- md-fg-input(label='Tên hiển thị *', v-model='fullname' :labelFloating='false', type='text' :required='true' placeholder="Nhập")
                .form-group.custom-form-group(:class="[isSubmitStep && fullname.length  === 0 ? 'error' : '']")
                  label.control-label Tên hiển thị *
                  input.form-control#fullname(type='text', v-model='fullname', required maxlength=125 placeholder="Nhập")
              .col-md-12(v-if="socialType === 1")
                md-fg-input(label='Email *', v-model='email' :labelFloating='false', type='text' :required='true' placeholder="example@gmail.com"
                  :class="[isSubmitStep && !validMail ? 'error' : '']")
              .col-md-12(v-if="socialType === 2")
                md-fg-input(label='Email *', v-model='email' :labelFloating='false', type='text' disabled=true placeholder="example@gmail.com")
              .col-md-12
                //- md-fg-input(label='Số điện thoại', v-model='phone_number' :labelFloating='false', type='text' :required='true' placeholder="Nhập")
                .form-group.custom-form-group(:class="[isSubmitStep && phone_number.length  === 0 ? 'error' : '']")
                  label.control-label Số điện thoại
                  input.form-control(type="text" 
                    name="phone_number" 
                    autocomplete="off"
                    placeholder="Nhập" 
                    v-model='phone_number'
                    maxlength = 10
                    :required='true'
                    @keypress="isAllow")
              .col-md-12
                md-fg-input(label='Ngày sinh của bạn', v-model='birthday' :labelFloating='false', type='date' :required='false'
                  :class="[isSubmitStep && isDate ? 'error' : '']")
                //- datetime(v-model="birthday" type="datetime" use12-hour)
            .row
              .col-md-9
                .form-group.custom-form-group
                  label.control-label Chọn trường học
                  select#school_id.form-control(@change='onChangeSchool($event)' required)
                    option(selected='true' disabled) Chọn
                    option(v-for='(o, index) in schools' :value='o.id') {{o.name}}
              .col-md-3.col-xs-6.reg-student-grade
                .form-group.custom-form-group
                  label.control-label Chọn khối lớp
                  itemGrade(:selected_school_id="isSelectedSchool ? selectedSchool : 0" :grades='grades' :schools='schools' @onGradeChange="onGradeChanged")
            .row
              .col-md-12.reg-student-subject
                p Môn học thế mạnh của bạn
              div.reg-student-beehive
                BeeHive(:lstItems="subjects", @onlstItems="onlstSubjects")
              div.reg-student-beehive-mobile
                BeeHiveMobile(:lstItemsMobile="subjects" @onlstItemsMobile="onlstSubjectsMobile")
            br
            .row
              .col-md-12(v-if="socialType === 1")
                .form-group.custom-form-group(style='position:relative;' :class="[isSubmitStep && this.password.length < 6 ? 'error' : '']")
                  label.control-label Mật khẩu đăng nhập *
                  input#password.form-control(v-model="password" :type='passwordType' required style='padding-right: 40px !important;' @keyup="checkPassword" placeholder="Nhập")
                  i.material-icons.reg-student-icon-password(@click="switchVisibility1st" v-if="passwordType === 'text'") visibility
                  i.material-icons.reg-student-icon-password(@click="switchVisibility1st" v-else) visibility_off
              .col-md-12(v-if="socialType === 1")
                .form-group.custom-form-group(style='position:relative;' :class="[isSubmitStep && (!this.matched || this.second_password.length < 6) ? 'error' : '']")
                  label.control-label Nhập lại mật khẩu *
                  input#second_password.form-control(v-model="second_password" :type='secondPasswordType' required style='padding-right: 40px !important;' @keyup="checkPassword" placeholder="Nhập")
                  i.material-icons.reg-student-icon-password(@click="switchVisibility2nd" v-if="secondPasswordType === 'text'") visibility
                  i.material-icons.reg-student-icon-password(@click="switchVisibility2nd" v-else) visibility_off
                  //- small(v-if="!matched" style="color: red") *Mật khẩu không khớp*
              .col-md-12(v-if="socialType === 1")
                vue-recaptcha(ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired" :sitekey="siteKey")
              .col-md-12
                p.reg-student-content Bằng cách chọn "Đăng ký" bạn đồng ý với 
                  span Điều khoản sử dụng 
                  | và 
                  span Chính sách bảo mật 
                  | của chúng tôi.
              .col-md-12
                div.col-md-6.col-12
                  div.text-right
                    button.reg-student-btn-validate.btn(@click='validateRegister') Đăng ký
                div.col-md-6.col-12
                  div.text-left
                    button.reg-student-btn-cancel.btn(@click="backLogin") Quay lại
          .clearfix          
</template>

<script>
import gql from 'graphql-tag'
import itemGrade from '../UserProfile/itemGrade'
import BeeHive from '../Subject/BeeHive'
import BeeHiveMobile from '../Subject/BeeHiveMobile'
import VueRecaptcha from 'vue-recaptcha'
import graphql from '../Model/graphql'
import firebase from 'firebase'
import store from '../../store'
import MdNotification from '@/core/components/mdNotification'
import moment from 'moment'

export default {
  components: {
    itemGrade,
    BeeHive,
    BeeHiveMobile,
    VueRecaptcha,
    MdNotification,
    moment
  },
  data() {
    return {
      username: '',
      birthday: new Date().toISOString().slice(0, 10),
      fullname: '',
      phone_number: '',
      email: '',
      captcha: null,
      password: '',
      second_password: '',
      isSelectedSchool: false,
      grades: [],
      schools: [],
      selectedSchool: null,
      selectedGrade: null,
      lstSubjected: [],
      socialType: 1,
      passwordType: 'password',
      secondPasswordType: 'password',
      captchaType: 'password',
      error: '',
      matched: true,
      checkName: null,
      siteKey: '6LcKzP8UAAAAABD2dgNkZ0u5gHRrvfDMZJeNz3a-',
      recaptchaVerified: false,
      front_params: null,
      isDate: false,
      isSubmitStep: false,
      validMail: false
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    switchVisibility1st() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    switchVisibility2nd() {
      this.secondPasswordType = this.secondPasswordType === 'password' ? 'text' : 'password'
    },
    switchVisibilityCaptcha() {
      this.captchaType = this.captchaType === 'password' ? 'text' : 'password'
    },
    checkPassword(e) {
      if (this.second_password !== this.password) {
        this.matched = false
      } else {
        this.matched = true
      }
    },
    checkUserName(username) {
      if (this.username !== null) {
        this.$apollo.queries.checkName.refresh()
      }
    },
    isAllow(event) {
      var key = window.event ? event.keyCode : event.which
      if (event.keyCode === 8 || event.keyCode === 46) {
        return true
      } else if (key < 48 || key > 57) {
        event.preventDefault()
        return false
      } else {
        return true
      }
    },
    onChangeSchool(e) {
      var id = e.target.value
      this.isSelectedSchool = true
      this.selectedSchool = parseInt(id)
    },
    onGradeChanged(id) {
      if (id) this.selectedGrade = parseInt(id)
    },
    onlstSubjects(lstItems) {
      if (lstItems) {
        this.lstSubjected = []
        for (var i = 0; i < lstItems.length; i++) {
          if (lstItems[i].selected === true) this.lstSubjected.push(lstItems[i])
        }
      }
    },
    onlstSubjectsMobile(lstItems) {
      if (lstItems) {
        this.lstSubjected = []
        for (var i = 0; i < lstItems.length; i++) {
          if (lstItems[i].selected === true) this.lstSubjected.push(lstItems[i])
        }
      }
    },
    checkDate() {
      this.isDate = false
      var date1 = new Date()
      date1 = moment(date1)
      var date2 = moment(this.birthday)
      if (date1 < date2) {
        this.isDate = true
      }
    },
    checkMail(text) {
      this.validMail = false
      if (text.length > 0) {
        if ((text.split('@').length - 1) < 1 || (text.split('@').length - 1) > 1) {
          this.validMail = false
        } else {
          let arrText = text.split('@')[1]
          if (arrText.length === 0) this.validMail = false
          else {
            let lastText = arrText.split('.').length
            if (lastText >= 2) this.validMail = true
            else this.validMail = false
          }
        }
      }
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        canCancel: false
      })
    },
    validateRegister() {
      const user = {
        email: this.email,
        password: this.password
      }
      // đăng ký account thường
      if (this.socialType === 1) {
        this.$apollo.queries.checkName.refresh()
        this.checkDate()
        this.checkMail(this.email)
        if (this.checkName !== null) {
          this.showNotification('Tên đăng nhập đã tồn tại', 'warning', 'top', 'right', 2000)
          this.error = 'Tên đăng nhập đã tồn tại'
          this.isSubmitStep = true
        } else if (this.username.length < 3) {
          this.showNotification('Tên đăng nhập phải có ít nhất 3 kí tự', 'warning', 'top', 'right', 2000)
          this.error = 'Tên đăng nhập phải có ít nhất 3 kí tự'
          this.isSubmitStep = true
        } else if (this.fullname.length === 0) {
          this.showNotification('Vui lòng nhập tên hiển thị', 'warning', 'top', 'right', 2000)
          this.error = 'Vui lòng nhập tên hiển thị'
          this.isSubmitStep = true
        } else if (this.email.length === 0) {
          this.showNotification('Vui lòng nhập Email', 'warning', 'top', 'right', 2000)
          this.error = 'Vui lòng nhập Email'
          this.isSubmitStep = true
        } else if (!this.validMail) {
          this.showNotification('Vui lòng xem lại định dạng Email', 'warning', 'top', 'right', 2000)
          this.error = 'Vui lòng xem lại định dạng Email'
          this.isSubmitStep = true
        } else if (this.phone_number.length === 0) {
          this.showNotification('Vui lòng nhập số điện thoại', 'warning', 'top', 'right', 2000)
          this.error = 'Vui lòng nhập số điện thoại'
          this.isSubmitStep = true
        } else if (this.isDate) {
          this.showNotification('Ngày sinh không được là ngày trong tương lai', 'warning', 'top', 'right', 2000)
          this.error = 'Ngày sinh không được là ngày trong tương lai'
          this.isSubmitStep = true
        } else if (this.password.length < 6) {
          this.showNotification('Mật khẩu phải có ít nhất 6 kí tự', 'warning', 'top', 'right', 2000)
          this.error = 'Vui lòng nhập mật khẩu'
          this.isSubmitStep = true
        } else if (!this.matched) {
          this.showNotification('Mật khẩu nhập lại không khớp', 'warning', 'top', 'right', 2000)
          this.error = 'Mật khẩu nhập lại không khớp'
          this.isSubmitStep = true
        } else if (this.username && this.fullname && this.email && this.password && this.matched) {
          if (!this.recaptchaVerified) {
            this.showNotification('Vui lòng nhập Captcha', 'warning', 'top', 'right', 2000)
            this.error = 'Vui lòng nhập Captcha'
            this.isSubmitStep = true
          } else {
            this.isSubmitStep = false
            this.show()
            this.$store.dispatch('signUpAction', user).then((res) => {
              // console.log('create hoc sinh: ', res)
              this.$apollo.mutate({
                mutation: gql(graphql.CREATE_USER),
                variables: {
                  users: [{
                    fullname: this.fullname,
                    username: this.username,
                    email: this.email,
                    phone_number: this.phone_number,
                    type_user: 1,
                    birthday: this.birthday,
                    school_id: this.selectedSchool,
                    grade_id: '{' + this.selectedGrade + '}',
                    social_type: this.socialType,
                    role: 'user'
                  }]
                }
              }).then(data => {
                for (var i = 0; i < this.lstSubjected.length; i++) {
                  this.$apollo.mutate({
                    mutation: gql(graphql.CREATE_USER_SUBJECT),
                    variables: {
                      subjects: [{
                        user_id: res.user.uid,
                        subject_id: this.lstSubjected[i].id
                      }]
                    }
                  })
                }
              }).then(data => {
                var user = firebase.auth().currentUser
                // console.log('sendEmailVerification: ', user)
                user.sendEmailVerification()
                .then(function () {})
                .catch((error) => {
                  console.error('error: ', error.message)
                })
                this.loader.hide()
                this.$store.commit('setIsHomePage', false)
                // console.log(this.front_params)
                if (this.front_params && this.front_params.name !== null) {
                  store.commit('setIsHomePage', true)
                  this.$store.dispatch('signOutAction')
                  this.$delete(this.front_params, 'name')
                  this.front_params = Object.assign(this.front_params, {name: 'Login'})
                  this.front_params = Object.assign(this.front_params, {params: {register_reload: true}})
                  this.$mycontroller.redirectToPageBeforeLogin(this.front_params)
                } else {
                  this.$store.dispatch('signOutAction')
                  this.$router.push({name: 'Login', params: {register_reload: true}})
                }
              }).catch((error) => {
                // this.deleteProfile()
                this.loader.hide()
                console.log(error)
              })
            }).catch((error) => {
              if (error.code === 'auth/argument-error') {
                this.showNotification('Mật khẩu không được để trống', 'warning', 'top', 'right', 2000)
                this.error = 'Mật khẩu không được để trống.'
              } else if (error.code === 'auth/invalid-email') {
                this.showNotification('Địa chỉ email không hợp lệ', 'warning', 'top', 'right', 2000)
                this.error = 'Địa chỉ email không hợp lệ.'
              } else if (error.code === 'auth/weak-password') {
                this.showNotification('Mật khẩu phải có ít nhất 6 kí tự', 'warning', 'top', 'right', 2000)
                this.error = 'Mật khẩu phải có ít nhất 6 kí tự.'
              } else if (error.code === 'auth/email-already-in-use') {
                this.showNotification('Địa chỉ email đã tồn tại', 'warning', 'top', 'right', 2000)
                this.error = 'Địa chỉ email đã tồn tại.'
              } else {
                console.log(error)
                this.error = error
              }
              this.loader.hide()
            })
          }
        } else {
          this.showNotification('Vui lòng kiểm tra lại thông tin Tên hiển thị, Tên đăng nhập, Email, Mật khẩu', 'warning', 'top', 'right', 2000)
          this.error = 'Vui lòng kiểm tra lại thông tin Tên hiển thị, Tên đăng nhập, Email, Mật khẩu'
        }
      } else if (this.socialType === 2) {
        // login google
        this.show()
        console.log('ĐĂNG KÝ ACCOUNT HỌC SINH BẰNG GOOGLE')
        this.$apollo.mutate({
          mutation: gql(graphql.CREATE_USER),
          variables: {
            users: [{
              fullname: this.fullname,
              username: this.email,
              email: this.email,
              phone_number: this.phone_number,
              type_user: 1,
              birthday: this.birthday,
              school_id: this.selectedSchool,
              grade_id: '{' + this.selectedGrade + '}',
              social_type: this.socialType,
              avatar: this.$route.params.newPicture,
              is_activated: true,
              role: 'user'
            }]
          }
        }).then(data => {
          for (var i = 0; i < this.lstSubjected.length; i++) {
            this.$apollo.mutate({
              mutation: gql(graphql.CREATE_USER_SUBJECT),
              variables: {
                subjects: [{
                  user_id: this.$store.getters.user,
                  subject_id: this.lstSubjected[i].id
                }]
              },
              error(error) {
                if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                  this.$router.go(0)
                }
              }
            })
          }
        }).then(data => {
          // this.$store.dispatch('signOutAction')
          this.loader.hide()
          this.$store.commit('setIsLoggedIn', true)
          if (this.front_params && this.front_params.name !== null) {
            this.$store.commit('setIsHomePage', true)
            this.$mycontroller.redirectToPageBeforeLogin(this.front_params)
          } else {
            this.$router.push({name: 'Account', params: {register_reload: true}})
          }
        }).catch((error) => {
          this.loader.hide()
          this.error = error
        })
      }
    },
    async deleteProfile () {
      let db = firebase.firestore()
      let ref = db.collection('users')
      let user = await ref.where('user_id', '==', firebase.auth().currentUser.uid).get()
      await user.ref.delete()
      await firebase.auth().currentUser.delete()
    },
    backLogin() {
      if (this.socialType === 2) {
        this.$store.dispatch('signOutAction')
        this.$store.commit('setIsLoggedIn', false)
      }
      this.$store.commit('setIsHomePage', false)
      if (this.front_params && this.front_params.name !== null) {
        this.$store.commit('setIsHomePage', true)
        let params = this.front_params
        let name = params.name
        this.$delete(params, 'name')
        this.$router.push({name: name, params: params})
      } else this.$router.push('login')
    },
    onCaptchaVerified: function (recaptchaToken) {
      this.recaptchaVerified = false
      if (recaptchaToken !== null && recaptchaToken !== '') {
        this.recaptchaVerified = true
      }
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset()
    }
  },
  created() {
    if (this.$route.params.front_top !== undefined) {
      this.front_params = this.$route.params
    }
    if (this.$route.params.newEmail) {
      this.email = this.$route.params.newEmail
      this.username = this.$route.params.newEmail
      this.socialType = 2
    }
    if (this.$route.params.newFullName) {
      this.fullname = this.$route.params.newFullName
    }
    this.$store.commit('setIsHomePage', false)
  },
  apollo: {
    grades: {
      query: gql(graphql.GET_GRADES),
      fetchPolicy: 'no-cache',
      update: data => {
        return data.grades
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    },
    schools: {
      query: gql(graphql.GET_SCHOOLS),
      fetchPolicy: 'no-cache',
      update: data => data.school,
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    },
    subjects: {
      query: gql(graphql.GET_SUBJECTS),
      fetchPolicy: 'no-cache',
      update: data => {
        for (var i = 0; i < data.subjects.length; i++) {
          data.subjects[i].selected = false
        }
        return data.subjects
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    },
    checkName: {
      query: gql(graphql.GET_USER_PUBLIC),
      fetchPolicy: 'no-cache',
      variables() {
        return { username: this.username }
      },
      update: data => {
        // console.log('apollo1: ', data)
        if (data && data.v_user_public && data.v_user_public.length === 0) {
          return null
        } else {
          return data.v_user_public[0].username
        }
      },
      skip() {
        return this.username === null || this.username === undefined || this.username === ''
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-reg-student-button: #FFD311;
}
.background-reg-student{
  background: #FBF4D2 url('../../assets/images/login/bg_pattern.png') no-repeat center 50%;
}
.body-reg-student {
  // width: 584px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 0px !important;
  display: block;
  font-family: 'adobe-clean', sans-serif;
  .reg-student-card {
    width: 584px;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 10px;
    opacity: 1;
    margin: 25px auto;
    display: block;
    .reg-student-card-content {
      padding-left: 10px;
      padding-right: 10px;
      .form-group{
        &.error{
          input, select{border: 1px solid #f00;}
          span.required{display: block; color: #f00; text-align: left;}
        }
      }
      .reg-student-title {
        font-weight: bold;
        text-align: center;
        margin-top: 20px;
        // padding-right: 0px;
        font-size: 17px;
      }
      .reg-student-alert {
        padding: 5px 15px;
        .form-group {
          margin-top: 0;
          .alert {
            margin-bottom: 0;
          }
        }
      }
      .reg-student-grade {
        padding-left: 0;
      }
      .reg-student-subject {
        font-weight: bold;
        color: #4B2D15;
        font-size: 15px;
      }
      .reg-student-beehive-mobile {
        display: none;
      }
      .reg-student-img {
        padding: 0;
        width: 140px;
      }
      .reg-student-captcha {
        width: 250px;
        height: auto;
        padding: 5px 0 10px;
      }
      .reg-student-content {
        color: #B4B4B4;
        font-size: 14px;
        span {
          color: #1A0DAB;
          text-decoration: underline;
        }
      }
      .reg-student-icon-password {
        margin-top: -43px; 
        display:block;
        position:absolute;
        right:10px;
        padding:auto 5px;
        &:hover {
          cursor: pointer;
        }
      }
      .reg-student-btn-validate {
        background: var(--color-reg-student-button);
        color:black;
        text-transform: none;
        font-size: 13px;
        border: 1px solid var(--color-reg-student-button);
        border-radius: 5px;
        // box-shadow: 0px 0px 0px;
        width: 160px;
        margin-bottom: 20px;
      }
      .reg-student-btn-cancel {
        background: white;
        color: black;
        text-transform: none;
        font-size: 13px;
        border: 1px solid var(--color-reg-student-button);
        border-radius: 5px;
        // box-shadow: 0px 0px 0px;
        width: 160px;
      }
    }
  }

@media (max-width: 991px) {
  .lo-custom-footer{text-align: center;
    .col-12{display: inline-block;
      .reg-student-btn-validate{float: none; margin-bottom:15px; margin-left: 0;}
      .reg-student-btn-cancel{float: none;  margin-bottom:15px; margin-right: 0;}
    }
  }
}
  // cellphones
  @media (max-width: 414px) {
    .reg-student-title {
      text-align: left !important;
      margin-left: -15px !important;
      padding: -10px;
    }
    .reg-student-btn-validate {
      float: left;
      margin: 0px;
      width: 115px !important;
      // padding: 12px;
    }
    .reg-student-btn-cancel {
      float: right;
      margin: 0px;
      width: 115px !important;
    }
  }
}

// cellphones
@media (max-width: 414px) {
  .body-reg-student {
    // width: 343px;
    // width: 100%;
    padding: 0 20px;
    .reg-student-card {
      width: 100%;
      .reg-student-card-content {
        padding-left: 10px;
        padding-right: 10px;
        .reg-student-title {
          margin-top: 0;
          padding: 10px 15px;
        }
        .reg-student-grade {
          padding-left: 15px;
        }
        .reg-student-beehive-mobile {
          display: block;
        }
        .reg-student-beehive {
          display: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// RegisterStudent.vue?16a2a516